module.exports = __webpack_public_path__ + "3f16e137/img/delete-icon.eb7de062.svg";